import Imatge from 'components/3catinfo/Imatge';
import Text from 'components/3catinfo/Text/Text';
import styles from '../cosminutaminut.module.scss';

const ImatgeCos = (props) => {
    let { src, alt, peu } = props;

    return (
        <div className={styles.imatgeCos} data-testid='cos-minutaminut-imatge'>
            <figure>
                <div className={styles.contentImg}>
                    <Imatge
                        src={src}
                        layout='fill'
                        objectFit='contain'
                        alt={alt}
                        className={styles.imgCos}
                        tipus='web_noti'
                        crop='1903'
                    />
                </div>
                {peu && (
                    <figcaption>
                        <Text text={peu} dataTestId='cos-noticia-imatge-peu' />
                    </figcaption>
                )}
            </figure>
        </div>
    );
};

export default ImatgeCos;
